module.exports = __webpack_public_path__ + "img/farzana-christopher-77.ebfd3b3f.jpg";